import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-callback',
  template: ''
})
export class GoogleCallbackComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const googleCallbackCode = params.code;
      this.authService.getGoogleToken(googleCallbackCode).subscribe(resGoogleToken => {
        console.log(resGoogleToken.access_token);
      });
    });
  }

}
